import { templateUserId } from '@/constants'

export const getUser = state => state.user
export const getToken = state => state.user.accessToken
export const getIsTemplatesUSer = state => {
  return +state.user.user.id_usuario === templateUserId
}


// WEBPACK FOOTER //
// ./src/store/getters/users.js